
import { Options, Vue } from 'vue-class-component';
import FieldDatePicker from '@/components/fields/FieldDatePicker.vue';
import FieldTotalSelector from '@/components/fields/FieldTotalSelector.vue';
import Button from '@/components/atoms/Button.vue';
import * as API from '@/api/book';
import { addDays, formatISO, toSearchQuery } from '@/dates';

@Options({
    components: {
        FieldDatePicker,
        FieldTotalSelector,
        Button,
    },
    props: {
        category: Object,
    },
    watch: {
        dates: {
            deep: true,
            handler() {
                this.result = null;
            },
        },
        guests: {
            deep: true,
            handler() {
                this.result = null;
            },
        },
    }
})

export default class AvailabilityBox extends Vue {

    // Props
    category!: API.AccommodationJson;


    dates = {
        start: new Date(),
        end: addDays(new Date(), 6),
    };

    guests = {
        adults: 2,
        children: 0,
    };

    hasSearch = false;

    result: API.SearchResultJson | null = null;

    get hasResult() {
        return !!this.result;
    }

    get isAvailable() {
        return this.result?.available === true;
    }

    get constraintMessage() {
        // TODO put this in a helper or something?
        // Preferably a gettext thing so translations/plurals are easy.
        // This is also somewhat duplicated in the booking store.
        const reason = this.result?.constraintMessage;
        if (!reason) return '';

        switch (reason[0]) {
            case 'min-nights':
                return `Please book at least ${reason[1]} nights.`;

            case 'max-nights':
                return `Please book not more than ${reason[1]} nights.`;

            case 'min-occupancy':
                return `Please book for at least ${reason[1]} guests.`;

            case 'max-occupancy':
                return `Please book no more than ${reason[1]} guests.`;

            default:
                return 'Not available.';
        }
    }


    async onSearch(event: Event) {
        event.preventDefault();

        if (this.isAvailable) {
            // Create a booking, push to the booking page.
            const booking = await API.createBooking({
                categoryId: this.category.categoryId,
                dateArrival: formatISO(this.dates.start),
                dateDeparture: formatISO(this.dates.end),
                adults: this.guests.adults,
                children: this.guests.children,
            });

            window.location.assign('/book?uid=' + booking.bookingId);
        }
        else {
            history.replaceState(null, '', location.pathname + '?' + toSearchQuery({
                dates: this.dates,
                guests: this.guests,
            }));

            this.result = await API.getSearch({
                categoryId: this.category.categoryId,
                dateFrom: formatISO(this.dates.start),
                dateTo: formatISO(this.dates.end),
                adults: this.guests.adults,
                children: this.guests.children,
            });

            this.hasSearch = true;
        }
    }


    async mounted() {
        const params = new URLSearchParams(window.location.search);
        let dateFrom, dateTo, adults, children;

        if (
            (dateFrom = params.get('dateFrom'))
            && (dateTo = params.get('dateTo'))
        ) {
            this.hasSearch = true;
            this.dates.start = new Date(dateFrom);
            this.dates.end = new Date(dateTo);
        }

        if (adults = params.get('adults')) {
            this.guests.adults = parseInt(adults);
        }

        if (children = params.get('children')) {
            this.guests.children = parseInt(children);
        }

        // Got some search bits so do a search.
        if (this.hasSearch) {
            this.result = await API.getSearch({
                categoryId: this.category.categoryId,
                dateFrom: formatISO(this.dates.start),
                dateTo: formatISO(this.dates.end),
                adults: this.guests.adults,
                children: this.guests.children,
            });
        }
    }
}
